<template>
  <div class="order-writeoff-confirm-container">
    <el-row class="flex-container">
      <el-col :span="6" class="writeoff-left">
        <div class="writeoff-panel bg-white">
          <div class="writeoff-title">核销台</div>
          <div class="writeoff-img">
            <img src="/img/writeoff_icon.png" />
          </div>
          <div class="writeoff-remark">请扫描核销二维码或输入核销码</div>
          <div class="writeoff-input">
            <el-input
              v-model="orderWriteOffConfirmInfo.woNum"
              placeholder="请输入核销码"
              @keyup.enter.native="confirmWriteOffOrder"
            ></el-input>
          </div>
          <div class="writeoff-submit">
            <el-button type="primary" @click="confirmWriteOffOrder">
              {{ $t('orderWriteOffConfirm.writeOff') }}
            </el-button>
          </div>
        </div>
      </el-col>

      <el-col :span="18" class="writeoff-right">
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('orderWriteOffConfirm.queryCondition') }}</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="orderWriteOffConfirmInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input
                  v-model="orderWriteOffConfirmInfo.conditions.personName"
                  :placeholder="$t('orderWriteOffConfirm.inputUserName')"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="orderWriteOffConfirmInfo.conditions.woNum"
                  :placeholder="$t('orderWriteOffConfirm.inputWriteOffNum')"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="queryOrderWriteOffConfirm">
                  {{ $t('orderWriteOffConfirm.query') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>核销订单</div>
          </div>
          <div class="">
            <el-table
              :data="orderWriteOffConfirmInfo.orders"
              border
              style="width: 100%"
            >
              <el-table-column
                prop="orderId"
                :label="$t('orderWriteOffConfirm.orderNum')"
                align="center"
              ></el-table-column>
              <el-table-column
                :label="$t('orderWriteOffConfirm.productName')"
                align="center"
              >
                <template v-slot="{row}">
                  <div v-for="(cart, index) in row.carts" :key="index">{{ cart.prodName }}</div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('orderWriteOffConfirm.quantity')"
                align="center"
              >
                <template v-slot="{row}">
                  <div v-for="(cart, index) in row.carts" :key="index">x {{ cart.cartNum }}</div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('orderWriteOffConfirm.productStatus')"
                align="center"
              >
                <template v-slot="{row}">
                  <div v-for="(cart, index) in row.carts" :key="index">{{ cart.stateName }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="personName"
                :label="$t('orderWriteOffConfirm.userName')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="payPrice"
                :label="$t('orderWriteOffConfirm.paymentAmount')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="woNum"
                :label="$t('orderWriteOffConfirm.writeOffNum')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="linkNum"
                :label="$t('orderWriteOffConfirm.phoneLastFour')"
                align="center"
              ></el-table-column>
              <el-table-column
                :label="$t('orderWriteOffConfirm.writeOffStatus')"
                align="center"
              >
                <template v-slot="{row}">
                  {{ row.state == '02' ? '到店核销' : '核销完成' }}
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                :label="$t('orderWriteOffConfirm.writeOffTime')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="remark"
                :label="$t('orderWriteOffConfirm.remark')"
                align="center"
              ></el-table-column>
              <el-table-column
                :label="$t('orderWriteOffConfirm.operation')"
                align="center"
              >
                <template v-slot="{row}">
                  <el-button
                    type="text"
                    size="small"
                    @click="openOrderDetailModel(row)"
                  >
                    {{ $t('orderWriteOffConfirm.orderDetail') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              @current-change="handlePageChange"
              :current-page="orderWriteOffConfirmInfo.conditions.page"
              :page-size="orderWriteOffConfirmInfo.conditions.row"
              layout="total, prev, pager, next"
              :total="orderWriteOffConfirmInfo.total"
            ></el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listStoreOrderWriteoff, confirmWriteOffOrder } from '@/api/order/orderWriteOffConfirmApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'OrderWriteOffConfirm',
  data() {
    return {
      orderWriteOffConfirmInfo: {
        orders: [],
        woNum: '',
        total: 0,
        conditions: {
          personName: '',
          woNum: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.listOrderWriteOffConfirms()
  },
  methods: {
    async listOrderWriteOffConfirms() {
      this.orderWriteOffConfirmInfo.conditions.shopId = getShopId()
      try {
        const res = await listStoreOrderWriteoff(this.orderWriteOffConfirmInfo.conditions)
        this.orderWriteOffConfirmInfo.orders = res.data
        this.orderWriteOffConfirmInfo.total = res.total
      } catch (error) {
        console.error('获取核销订单列表失败:', error)
      }
    },
    async confirmWriteOffOrder() {
      if (!this.orderWriteOffConfirmInfo.woNum) {
        this.$message.warning('请扫码')
        return
      }
      
      const params = {
        woNum: this.orderWriteOffConfirmInfo.woNum,
        shopId: getShopId()
      }
      
      try {
        await confirmWriteOffOrder(params)
        this.$message.success('核销成功')
        this.orderWriteOffConfirmInfo.woNum = ''
        this.listOrderWriteOffConfirms()
      } catch (error) {
        this.$message.error(error.message || '核销失败')
      }
    },
    queryOrderWriteOffConfirm() {
      this.orderWriteOffConfirmInfo.conditions.page = 1
      this.listOrderWriteOffConfirms()
    },
    handlePageChange(currentPage) {
      this.orderWriteOffConfirmInfo.conditions.page = currentPage
      this.listOrderWriteOffConfirms()
    },
    openOrderDetailModel(order) {
      this.$router.push(`/pages/goods/storeOrderCartDetail?orderId=${order.orderId}`)
    }
  }
}
</script>

<style scoped>
.order-writeoff-confirm-container {
  padding: 20px;
}
.flex-container {
  display: flex;
}
.writeoff-left {
  padding-right: 20px;
}
.writeoff-panel {
  padding: 20px;
  border-radius: 4px;
  text-align: center;
}
.writeoff-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}
.writeoff-img {
  margin-bottom: 20px;
}
.writeoff-remark {
  margin-bottom: 20px;
  color: #666;
}
.writeoff-input {
  margin-bottom: 20px;
}
.writeoff-submit {
  margin-top: 20px;
}
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
}
.ibox-title {
  padding: 15px;
  border-bottom: 1px solid #eee;
}
.ibox-title h5 {
  margin: 0;
  font-size: 16px;
}
.ibox-content {
  padding: 15px;
}
</style>